(() => {
  if (document.documentElement.dataset.bythlonVideoReady) return;
  document.documentElement.dataset.bythlonVideoReady = 'true';
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-bythlon-video-open]');
    if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const dialog = document.querySelector('[data-bythlon-video-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    if (dialog.open) return;
    const player = dialog.querySelector('[data-bythlon-video-player]');
    document.querySelectorAll('video').forEach(video => video.pause());
    const cleanup = () => {
      player.replaceChildren();
      document.documentElement.classList.remove('bythlon-video-open');
      if (trigger.isConnected) trigger.focus({ preventScroll: true });
    };
    dialog.addEventListener('close', cleanup, { once: true });
    if (!dialog.dataset.ready) {
      dialog.dataset.ready = 'true';
      dialog.querySelector('[data-bythlon-video-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', click => {
        if (click.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (click.clientX < bounds.left || click.clientX > bounds.right || click.clientY < bounds.top || click.clientY > bounds.bottom) dialog.close();
      });
    }
    dialog.showModal();
    document.documentElement.classList.add('bythlon-video-open');
    player.replaceChildren(dialog.querySelector('template').content.cloneNode(true));
  });
})();
